// analytics constants
export const SOURCE_NAME = 'issueTypeScreenSchemeDirectory';
export const ADD_ISSUE_TYPE_SCREEN_SCHEME = 'addIssueTypeScreenScheme';
export const ISSUE_TYPE_SCREEN_SCHEMES_TABLE = 'issueTypeScreenSchemesTable';
export const SCREEN_SCHEMES = 'screenSchemes';
export const SCREENS = 'screens';
export const ASSOCIATED_PROJECTS = 'associatedProjects';
export const ISSUE_TYPE_SCREEN_SCHEME_NAME = 'issueTypeScreenSchemeName';
export const ISSUE_TYPE_SCREEN_SCHEME = 'issueTypeScreenScheme';
export const PROJECT = 'project';
export const SORT_ORDER = 'sortOrder';
export const ISSUE_TYPE_SCREEN_SCHEMES_COLUMN = 'issueTypeScreenSchemesColumn';
export const PAGE = 'page';
export const ISSUE_TYPE_SCREEN_SCHEME_ACTIONS = 'issueTypeScreenSchemeActions';
export const ORDER = Object.freeze({
	ASC: 'asc',
	DESC: 'desc',
});
export const CURRENT_PAGE = 'currentPage';
export const MAXIMUM_PAGE = 'maximumPage';

// test id constants
export const ISSUE_TYPE_SCREEN_SCHEME_HELP_BUTTON =
	'admin-pages-issue-type-screen-schemes-page.ui.add-issue-type-help-button';
export const ADD_ISSUE_TYPE_SCREEN_SCHEME_BUTTON =
	'admin-pages-issue-type-screen-schemes-page.ui.add-issue-type-button';
